<template>
  <svg class="d-block" xmlns="http://www.w3.org/2000/svg" :viewBox="'0 0 ' + (wrapWidth * 0.85) + ' ' + height">
    <text
      :class="[ data.class ]"
      :fill="fill"
      text-anchor="middle"
      dominant-baseline="hanging"
      ref="txtEl"
    >
      <tspan v-for="(txt, idx) in text.split('<br>')" x="50%" :dy="idx === 0 ? '' : '1.5em'">{{ txt }}</tspan>
    </text>
  </svg>
</template>

<script>
  import { gradPtColor } from '@/lib/funcs'
  import TextMixin from '@/components/report/mixins/TextMixin'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'GradTextFragment',
    mixins: [ TextMixin, StateMixin ],
    props: {
      wrapWidth: { type: Number, default () { return Math.min( 600, window.innerWidth ) } }
    },
    data () {
      return { height: 275 }
    },
    computed: {
      fill () {
        return gradPtColor( ...this.colorsRev, 0.5 )
      },
      text () {
        return this.isSmall ? this.data.txt : this.data.deskTxt
      }
    },
    mounted () {
      this.height = this.$refs.txtEl.getBBox().height
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";

  .grad-text {
    &-quote {
      font-family : $adobe-clean-serif;
      font-size   : rem(30);
      line-height : rem(42);
      font-style  : italic;
      font-weight : 500;
      text-align  : center;

      .style-extended & {
        font-size   : rem(37);
        line-height : rem(50);
      }

      @include screen-md-lg-xl {
        font-size   : rem(38);
        line-height : rem(56);
      }
    }
  }

  svg {
    width        : 85%;
    margin-left  : auto;
    margin-right : auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/GradTextFragment.vue